import { __awaiter } from "tslib";
import { isBoolean } from 'lodash';
import { OFLOW_COMMAND_CATEGORY, getCommandCategory } from './interface';
import { NodeCommand } from './node-command';
import { EdgeCommand } from './edge-command';
import { GroupCommand } from './group-command';
import { AdvancedCommand } from './advance-command';
export * from './interface';
export class Command {
    constructor({ canvas, canvasId, model }) {
        this.commandRunningStatus = 'NONE';
        this.execute = (command, args = {}) => __awaiter(this, void 0, void 0, function* () {
            this.commandRunningStatus = 'RUNNING';
            let res = false;
            if (!isBoolean(args.traceCommand)) {
                args.traceCommand = true;
            }
            const category = getCommandCategory(command);
            try {
                const previousCommandHooks = this.model.oFlowModel.getCommandPreviousHooks(command);
                const postCommandHooks = this.model.oFlowModel.getCommandPostHooks(command);
                const newArgs = Object.assign({}, args);
                for (const previousHookFn of previousCommandHooks) {
                    newArgs['payload'] = yield previousHookFn({ payload: newArgs.payload, canvasModel: this.model });
                }
                ;
                switch (category) {
                    case OFLOW_COMMAND_CATEGORY.NODE_COMMAND:
                        res = yield this.nodeCommand.execute(command, newArgs);
                        break;
                    case OFLOW_COMMAND_CATEGORY.EDGE_COMMAND:
                        res = yield this.edgeCommand.execute(command, newArgs);
                        break;
                    case OFLOW_COMMAND_CATEGORY.GROUP_COMMAND:
                        res = yield this.groupCommand.execute(command, newArgs);
                        break;
                    case OFLOW_COMMAND_CATEGORY.ADVANCED_COMMAND:
                        res = yield this.advancedCommand.execute(command, newArgs);
                        break;
                }
                ;
                for (const postHookFn of postCommandHooks) {
                    postHookFn({ payload: newArgs.payload, canvasModel: this.model });
                }
                ;
            }
            catch (error) {
                console.log('oflow: 命令执行异常', error);
            }
            this.commandRunningStatus = 'NONE';
            console.log('oflow: 命令执行成功', command, `params:`, args);
            return res;
        });
        this.canvasId = canvasId;
        this.canvas = canvas;
        this.model = model;
        this.nodeCommand = new NodeCommand({ model });
        this.edgeCommand = new EdgeCommand({ model });
        this.groupCommand = new GroupCommand({ model });
        this.advancedCommand = new AdvancedCommand({ model });
    }
    get isCommandRunning() {
        return this.commandRunningStatus === 'RUNNING';
    }
    undo() {
        this.commandRunningStatus = 'RUNNING';
        this.model.undoCanvasData();
        this.commandRunningStatus = 'NONE';
    }
    redo() {
        this.commandRunningStatus = 'RUNNING';
        this.model.redoCanvasData();
        this.commandRunningStatus = 'NONE';
    }
}
//# sourceMappingURL=index.js.map